import { genericPage, getServerSidePropsHelper } from 'components/corporatiu/Page';
import { useRouter } from 'next/router';

let path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'tv3', 'marato', 'fundacio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    let idSeccio = '';
    let layoutName = slug;

    if (/^memoria-\d{4}$/.test(slug)) {
        layoutName = 'memoria';
        idSeccio = slug.slice(-4);
    } else {
        switch (slug) {
            case 'organs-govern-i-equip':
                idSeccio = 43;
                break;
            case 'publicacions':
                idSeccio = 46;
                break;
            case 'recaptacions':
                idSeccio = 45;
                break;
            case 'xifres':
                idSeccio = 90;
                break;
            case 'transparencia':
                break;
            default:
                return {
                    notFound: true
                };
        }
    }

    path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'tv3', 'marato', 'fundacio', layoutName];

    const options = {
        slugs: path,
        id: idSeccio
    };
    context.query.lang = 'ca';
    context.query.id = idSeccio;
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
